import React from 'react';
import * as Styles from './Styles';
import Selectable from './Selectable';
import * as ExtendedContent from './extendedContent';
import PaginatedDescription from '../../../../../components/paginatedDescription/PaginatedDescription';
import { IRisk } from '../../../../../models/Dictionaries';
import * as FormManager from '../../../../../reducers/ui/form';

const TopContentTile = (props: { label: string; sub: string }) => (
	<Styles.TileContainer>
		<p>{props.label.split(',').join(' ')}</p>
		<div />
		<p>{props.sub}</p>
	</Styles.TileContainer>
);

export const OPHeading = () => (
	<>
		<p>klauzula ubezpieczenia Kosztów Ochrony Prawnej</p>
		<p>
			wybierz sumę gwarancyjną ubezpieczenia{' '}
			<span>(zaznacz odpowiedni kafelek)</span>
		</p>
	</>
);

export const OPTopContent = (props: {
	risks: IRisk[];
	selectedRisksIds: number[];
}) => (
	<Styles.TopContentContainer>
		<Styles.SelectablesContainer>
			{props.risks.map((risk) => {
				const riskState = props.selectedRisksIds.includes(risk.riskId);

				return (
					<Selectable
						key={risk.riskId}
						label={
							<TopContentTile
								label={`${risk.riskInsuranceAmount.toLocaleString()} zł`}
								sub={`${risk.riskContribution} zł`}
							/>
						}
						onClick={() =>
							FormManager.toggleSelectRisk(risk.riskId, 'kop')
						}
						selected={riskState}
					/>
				);
			})}
			<Selectable
				label="NIE WYBIERAM"
				onClick={() => FormManager.clearSelectedKOPRisks()}
				selected={
					!props.risks.some((el) =>
						props.selectedRisksIds.includes(el.riskId)
					)
				}
				className="w-33"
				style={{ fontSize: '15px' }}
			/>
		</Styles.SelectablesContainer>
	</Styles.TopContentContainer>
);

export const OPExtendedContent = () => (
	<PaginatedDescription content={ExtendedContent.OP} />
);
